import * as z from 'zod'

import phoneUtil from '@/utils/phoneUtil'

// 與後端 register / password 的 minLength 契約一致，調整時須同步後端
export const PASSWORD_MIN_LENGTH = 6

export const createPasswordSchema = (t, minLength = PASSWORD_MIN_LENGTH) => z.string().min(minLength, { message: t('description.password_invalid') })

// 使用 https://github.com/typestack/class-validator 的 isEmail 驗證邏輯 (同後端)
export const isEmail = (str) => {
  if (!str || typeof str !== 'string' || str.length > 254) return false

  const parts = str.split('@')
  if (parts.length !== 2) return false

  const [user, domain] = parts
  if (user.length > 64 || user.length === 0 || domain.length > 254 || domain.length === 0) return false

  // User part validation
  const userPartRegex = /^[a-z\d!#$%&'*+\-/=?^_`{|}~]+$/i
  const userParts = user.split('.')
  for (let i = 0; i < userParts.length; i++) {
    if (!userPartRegex.test(userParts[i])) return false
  }

  // Domain part validation (FQDN)
  const domainParts = domain.split('.')
  if (domainParts.length < 2) return false

  for (let i = 0; i < domainParts.length; i++) {
    const part = domainParts[i]
    if (part.length === 0 || part.length > 63) return false
    if (!/^[a-z\d-]+$/i.test(part) || part.startsWith('-') || part.endsWith('-')) return false
  }

  // TLD validation: validator.js requires TLD to be at least 2 characters
  const tld = domainParts[domainParts.length - 1]
  if (!/^[a-z]{2,}$/i.test(tld)) return false

  return true
}

export const createEmailSchema = (t) => z.string().refine(isEmail, { message: t('description.email_invalid') })

export const USERNAME_REGEX = /^(?=.*[a-z])[a-z0-9_]{3,19}[a-z0-9]$/

export const createUsernameSchema = (t) =>
  z.string().regex(USERNAME_REGEX, {
    message: t('description.account_invalid'),
  })

export const createPhoneSchema = (countryCode, t) =>
  z.string().refine((phone) => phoneUtil.isValid(`+${countryCode} ${phone}`), {
    message: t('description.phone_invalid'),
  })

// 計算 'YYYY-MM-DD' 距今實足年齡，無效日期回傳 null
export const getAge = (dateStr) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr || '')) return null

  const [year, month, day] = dateStr.split('-').map(Number)
  const birth = new Date(year, month - 1, day)
  // 還原後不一致代表日期不存在（如 2 月 30 日）
  if (birth.getFullYear() !== year || birth.getMonth() !== month - 1 || birth.getDate() !== day) return null

  const today = new Date()
  let age = today.getFullYear() - year
  const hasNotHadBirthday = today.getMonth() < month - 1 || (today.getMonth() === month - 1 && today.getDate() < day)
  if (hasNotHadBirthday) age--
  return age
}

export const isAdult = (dateStr, minAge = 18) => {
  const age = getAge(dateStr)
  return age !== null && age >= minAge
}

export const createBirthdaySchema = (t, minAge = 18) =>
  z
    .string()
    .min(1, { message: t('common.fieldRequired', { field: t('common.birthday') }) })
    .refine((value) => isAdult(value, minAge), { message: t('description.birthday_age_verification_failed') })
